module.exports = __webpack_public_path__ + "static/media/icon-signature.696c8f12.svg";